import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import MensajeNotFound from "./MensajeNotFound";
import Sircreb from "./ViewSIRCREB";
import Sirtac from "./ViewSIRTAC";

import "../styles/util.css";

function ViewModal({ data, sistema,cuit, anio, mes }) {  
 
  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);  

  return (
    <Modal
      show={show}
      onHide={handleClose}
      animation={false}
      size="lg"
      centered
      scrollable
      className="modalp"
    >     
      <Modal.Header closeButton className="title-modal ">
        Consulta Coeficientes de Distribución 
      </Modal.Header>
      <Modal.Body className="mt-0 ml-1 mr-3">
        {(data.sistema==='sircreb' || data.sistema==='sircupa') && <Sircreb data={data} anio={anio} mes={mes}/>}
        {(data.sistema==='sirtac') && <Sirtac data={data}  anio={anio} mes={mes}/>}
        
        {data.error && (
          <MensajeNotFound           
            motivo  = {data.error.detail}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ViewModal;
